import { styled } from '@mui/material'
import OverflowText from 'components/ui/OverflowText'

const Span = styled('span')({
  display: 'flex',
})

interface Props {
  filename: string
  className?: string
}

const OverflowFilename = ({ filename, className }: Props) => {
  const [name, ext] = (filename.match(/^(.+)(\.[^.]+)$/) || ['', filename, '']).slice(1, 3)

  return (
    <Span className={className}>
      <OverflowText>{name}</OverflowText>
      {ext}
    </Span>
  )
}

export default OverflowFilename
